import { Box } from '@mui/material';
import { colors } from '../../../styles/colors';

interface MethodChipProps {
  method: string;
}

const METHOD_COLORS: Record<string, string> = {
  GET: colors.status.running,
  POST: colors.status.concluded,
  PUT: colors.status.pending,
  PATCH: colors.status.pending,
  DELETE: colors.status.rejected,
};

export const MethodChip = ({ method }: MethodChipProps) => {
  const color = METHOD_COLORS[method?.toUpperCase()] ?? colors.brand.textSecondary;
  return (
    <Box
      component="span"
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        height: 20,
        px: 0.875,
        borderRadius: '6px',
        border: `1px solid ${color}55`,
        backgroundColor: `${color}14`,
        color,
        fontFamily: "'JetBrains Mono', monospace",
        fontSize: '10.5px',
        fontWeight: 600,
        letterSpacing: '0.04em',
      }}
    >
      {method ?? '—'}
    </Box>
  );
};
